<ngx-gallery #gallery [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
